import { getUserOs } from '@rhg/utils/browser';
import { ReactNode, useEffect, useRef } from 'react';
import { useTracking } from '../use-tracking';

export function TrackDeviceType({ children }: { children: ReactNode }) {
    const { setUserProfile } = useTracking();
    const isTracked = useRef(false);
    const os = getUserOs();
    useEffect(() => {
        if (!isTracked.current) {
            setUserProfile({
                'Device type': os.name,
            }).catch(() => {});
            isTracked.current = true;
        }
    }, [setUserProfile, os]);
    return <>{children}</>;
}
